import { useLocation } from 'react-router-dom';

export interface PageInfo {
  path: string;
  name: string;
  isActive: boolean;
}

export const useCurrentPage = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const pages = [
    { path: '/', name: 'Главная' },
    { path: '/about', name: 'О нас' },
    { path: '/services', name: 'Услуги' },
    { path: '/documents', name: 'Документы' },
    { path: '/contact', name: 'Контакты' },
    { path: '/booking', name: 'Запись' },
  ];

  const currentPage = pages.find(page => page.path === currentPath);
  
  return {
    currentPath,
    currentPage: currentPage || { path: currentPath, name: 'Неизвестная страница' },
    isHomePage: currentPath === '/',
    isAboutPage: currentPath === '/about',
    isServicesPage: currentPath === '/services',
    isDocumentsPage: currentPath === '/documents',
    isContactPage: currentPath === '/contact',
    isBookingPage: currentPath === '/booking',
  };
};
